const ADMIN_TOOL_OBJECT = {
  'mapping':[{
    name: 'Orgs',
    value: 'organizations',
    key: '',
  },
  {
    name: 'Sections',
    value: 'sections',
    key:'',
  },
  {
    name: 'Teachers',
    value: 'teachers',
    key:''
  },
  {
    name: 'Students',
    value: 'students',
    key:''
  },
  {
    name: 'People',
    value: 'people',
    key:''
  }],

  'orchestration': [{
    name: 'Org',
    value: 'organization',
    key: '',
    dependencies: 'People, Course & Section'
  }, {
    name: 'Person',
    value: 'person',
    key: '',
    dependencies: 'Section'
  }, {
    name: 'Section & Enrollments',
    value: 'section',
    key:''
  }, {
    name: 'ConnectED Licensing',
    value: 'connected',
    key:''
  } ],
  services: [{
    name: 'All',
    value: 'all',
    key: '',
  } ,{
    name: 'ETL',
    value: 'etl',
    key: '',
  }, {
    name: 'Organizations',
    value: 'organizations',
    key: '',
  }, {
    name: 'Users',
    value: 'users',
    key: '',
  }, {
    name: 'Sections',
    value: 'sections',
    key: '',
  }, {
    name: 'Jobs',
    value: 'jobs',
    key: '',
  }, {
    name: 'DBB Consumer',
    value: 'dbbConsumer',
    key: '',
  }],
  'deleteEntites': [{
    name: 'Org',
    value: 'organization',
    key: '',
  },
  {
    name: 'Person',
    value: 'person',
    key: ''
  },
  {
    name: 'Section',
    value: 'section',
    key: '',
  },
  {
    name: 'Course',
    value: 'course',
    key: ''
  },
  {
    name: 'Academic Session',
    value: 'academicSession',
    key: ''
  }],
};


export default  ADMIN_TOOL_OBJECT;



// WEBPACK FOOTER //
// ./app/models/adminToolSection.js